import { Controller } from "@hotwired/stimulus"

// Hands Safari back to the native app after a handed-off checkout: opens
// the app's URL scheme once the page has settled. The button on the page
// covers the case where Safari's "Open in Sindi?" prompt was dismissed.
export default class extends Controller {
  static values = { url: String }

  connect() {
    if (!this.urlValue) return
    this.timer = setTimeout(() => { window.location.href = this.urlValue }, 400)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
